module.exports = __webpack_public_path__ + "static/curate-products-42f0d5004f2af51def8f984dac245d9e.png";